const MAX_CARD_ID_DIGITS = 6;

/** Path used in QR codes: https://yoursite.com/card/905 */
export const CARD_QR_PATH_PREFIX = "/card/";

export function buildCardQrUrl(cardId, origin = typeof window !== "undefined" ? window.location.origin : "") {
  const id = String(cardId ?? "").trim();
  return `${origin}${CARD_QR_PATH_PREFIX}${id}`;
}

export function buildProductUrl(productId, origin = typeof window !== "undefined" ? window.location.origin : "") {
  const id = String(productId ?? "").trim();
  return `${origin}/products/id/${id}`;
}

/**
 * Parse Card.id from QR URL, plain digits, or legacy barcode text.
 */
export function parseCardIdFromScan(text) {
  const trimmed = (text || "").trim();
  if (!trimmed) return "";

  const pathMatch = trimmed.match(/\/card\/(\d{1,6})\b/i);
  if (pathMatch) return pathMatch[1];

  try {
    const url = new URL(trimmed, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    const fromPath = url.pathname.match(/\/card\/(\d{1,6})\b/i);
    if (fromPath) return fromPath[1];
  } catch {
    /* not a URL */
  }

  if (/^\d+$/.test(trimmed)) {
    if (trimmed.length > MAX_CARD_ID_DIGITS) return "";
    return trimmed;
  }

  const chunks = (trimmed.match(/\d+/g) || []).filter(
    (c) => c.length >= 1 && c.length <= MAX_CARD_ID_DIGITS
  );
  if (!chunks.length) return "";

  const cardLike = chunks.filter((c) => c.length >= 3 && c.length <= 5);
  const pool = cardLike.length ? cardLike : chunks;
  return pool.reduce((a, b) => (a.length <= b.length ? a : b));
}
